import React from 'react';

export const Financeiro: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900">Financeiro</h1>
      <p>Página em construção.</p>
    </div>
  );
};
